import {parseForm} from "@jalik/form-parser";
import __ from "lodash";
import '../utils';

const handle = async (e) => {
    const form = e.target;
    const response = await requestWithCsrf('/user/confirmed-two-factor-authentication', parseForm(form));

    const data = await response.json();

    if (response.status !== 200) {
        messages({
            errors: true,
            message: data.message,
        }, 'toast-top-right');
        form.reset();
        return false;
    }
    messages({
        success: true,
        message: __('2FA successfully confirmed').toString(),
    }, 'toast-top-right');

    return true;
};

export default handle;
